import { API_REQUEST, TOKEN_REFRESH, TOKEN_SET } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";


export const setToken = (tokenSet: boolean): AppAction => ({
    type: TOKEN_SET,
    payload: {},
    value: tokenSet
});

export const refreshToken = (userProfileId: string, token: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/token/${userProfileId}`,
        next: TOKEN_REFRESH,
        method: 'GET',
        authorization: token,
    }
});